export default __webpack_public_path__ + "static/media/smallbanners_Motial-Oswal-Large-and-Midcap-Fund.4a9a8bbd.jpg";